module.exports = __webpack_public_path__ + "img/1473978699.f442ec6e.jpg";